export const SITE_NAME = "AI Planet (formerly DPhi)";
